module.exports = __webpack_public_path__ + "static/media/Impreza-GJ-Sedan-WRX.21b261a4.jpg";